import { CallHeatmapCellDTO } from "../../HubSpot/useGetSchedulerCloserDetail.ts";

const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

function cellStyle(calls: number, max: number): { backgroundColor: string } {
  if (calls === 0) return { backgroundColor: "#F1F5F9" };
  const opacity = 0.2 + 0.8 * (calls / max);
  return { backgroundColor: `rgba(30, 66, 159, ${opacity.toFixed(2)})` };
}

export function CallHeatmap({ cells }: { cells: CallHeatmapCellDTO[] }) {
  if (cells.length === 0) {
    return (
      <p className="text-sm text-slate-400">
        Nessuna call dello scheduler nel periodo.
      </p>
    );
  }
  const hours = cells.map((c) => c.hour);
  const firstHour = Math.min(...hours);
  const lastHour = Math.max(...hours);
  const hourRange = Array.from(
    { length: lastHour - firstHour + 1 },
    (_, i) => firstHour + i,
  );
  const max = Math.max(...cells.map((c) => c.calls));
  const callsAt = (weekday: number, hour: number): number =>
    cells.find((c) => c.weekday === weekday && c.hour === hour)?.calls ?? 0;

  return (
    <div className="overflow-x-auto">
      <table className="text-xs border-separate border-spacing-1">
        <thead>
          <tr>
            <th />
            {hourRange.map((hour) => (
              <th key={hour} className="font-normal text-slate-400 w-8">
                {String(hour).padStart(2, "0")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {WEEKDAYS.map((label, weekday) => (
            <tr key={label}>
              <td className="pr-2 text-slate-500">{label}</td>
              {hourRange.map((hour) => {
                const calls = callsAt(weekday, hour);
                return (
                  <td
                    key={hour}
                    title={`${label} ${String(hour).padStart(2, "0")}:00 · ${calls} call`}
                    className="h-6 w-8 rounded text-center tabular-nums"
                    style={cellStyle(calls, max)}
                  >
                    <span
                      className={
                        calls > max / 2 ? "text-white" : "text-slate-600"
                      }
                    >
                      {calls > 0 ? calls : ""}
                    </span>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
